import React, { useState, useEffect, useContext } from "react";
import "./style.scss";
import { Modal } from "react-bootstrap";
import SelectedDoctors from "./SelectedDoctor";
import StaffSearchbar from "../StaffSearchbar";
import StaffContext from "../../StaffContext";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import DoctorContactsNew from "./DoctorContactsNew";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import SelectedDoctorsNew from "./SelectedDoctorNew";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";
import { setDynamicCookieForUser } from "../../../../Util/API Calls/cookieHelper";
import { useCookies } from "react-cookie";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";

const AllDoctorsContent = (props) => {
  const { show, onHide } = props;
  const staff_context = useContext(DoctorContext);
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctors, setselectedDoctors] = useState([]);
  const [selectedDoctorsDup, setselectedDoctorsDup] = useState([]);
  const [searchedPatient, setSearchedPatient] = useState("");
  const [filteredDoctors, setfilteredDoctors] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [approvedPatients, setApprovedPatients] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateFlag, setupdateFlag] = useState(false);
  const [openSmsTab, setopenSmsTab] = useState(false);
  const [openSlugList, setopenSlugList] = useState(false);
  const [data, setdata] = useState({});
  const [share, setshare] = useState(false);
  const [sentmodal, setsentmodal] = useState(false);
  const [emailmdal, setemailmdal] = useState(false);
  const [emailapprovedPatients, setEmailApprovedPatients] = useState([]);
  const [emailpatients, setEmailPatients] = useState([]);
  const [search_string, setsearch_string] = useState("");
  const [smsBody, setsmsBody] = useState(true);
  const [clicked, setclicked] = useState("");
  const [inputText, setInputText] = useState("");

  const [cookies, setCookie] = useCookies(["cookie-name"]);

  const onSubmit = (event) => {
    setInputText(event["search_string"]);
  };

  const onClearData = () => {
    setInputText("");
  };

  useEffect(() => {
    setDoctors(staff_context.doctorList);
    if (staff_context?.selectedDoctor?.length > 0) {
      setselectedDoctors(
        staff_context?.selectedDoctor?.filter(
          (doctor) => doctor.selected === true
        )
      );
    }
    setselectedDoctorsDup(staff_context?.selectedDoctor);
  }, [staff_context.selectedDoctor, staff_context.doctorList]);

  useEffect(() => {
    setfilteredDoctors(
      doctors
        ?.filter((doct) => {
          return (
            doct?.name?.toLowerCase()?.includes(inputText?.toLowerCase()) || //searcheddoct
            doct?.dr_phone_no?.includes(inputText) //searchedPatient
          );
        })
        .sort((a, b) => {
          const firstNameA = a.dr_first_name
            ? a.dr_first_name.trim()
            : "" + a.dr_middle_name
            ? " " + a.dr_middle_name.trim()
            : "" + a.dr_last_name
            ? " " + a.dr_last_name.trim()
            : "";
          const firstNameB = b.dr_first_name
            ? b.dr_first_name.trim()
            : "" + b.dr_middle_name
            ? " " + b.dr_middle_name.trim()
            : "" + b.dr_last_name
            ? " " + b.dr_last_name.trim()
            : "";

          return firstNameA.localeCompare(firstNameB);
        })
    );
  }, [inputText, doctors]); //searchedPatient

  const handleCheckDoctorContacts = (event) => {
    setLoading(true);
    let patientsAvailable = [...doctors];
    let patientsSelected = [...selectedDoctors];
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === event.target.value) {
        patientsAvailable[i].selected = event.target.checked;
        if (event.target.checked) {
          if (
            !patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected.push(patientsAvailable[i]);
          }
        } else {
          if (
            patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected = patientsSelected.filter(
              (ps) => ps.id !== patientsAvailable[i].id
            );
          }
        }
      }
    }
    if (patientsSelected.length < doctors.length && checkedAll === true) {
      setCheckedAll(false);
    }
    if (patientsSelected.length === doctors.length && checkedAll === false) {
      setCheckedAll(true);
    }
    setselectedDoctors(patientsSelected);
    setDoctors(patientsAvailable);
    setLoading(false);
  };

  useEffect(() => {
    if (
      filteredDoctors.length > 0 &&
      selectedDoctors.length > 0 &&
      filteredDoctors.length === selectedDoctors.length
    )
      setCheckedAll(true);
  }, [show, filteredDoctors]);

  const removeSelectedDoctors = (index) => {
    let patientsSelected = [...selectedDoctors];
    let patientsAvailable = [...doctors];
    patientsSelected = patientsSelected.filter((ps) => ps.id !== index);
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === index) {
        patientsAvailable[i].selected = false;
      }
    }
    if (patientsSelected.length < doctors.length && checkedAll === true) {
      setCheckedAll(false);
    }
    setselectedDoctors(patientsSelected);
    setDoctors(patientsAvailable);
  };

  const removeApprovedPatient = (e, index) => {
    e.stopPropagation();
    if (smsBody) {
      let patientsApproved = [...approvedPatients];
      patientsApproved = patientsApproved.filter((pa) => pa.id !== index);
      if (patientsApproved.length < doctors.length && checkedAll === true) {
        setCheckedAll(false);
      }
      setApprovedPatients(patientsApproved);
      removeSelectedDoctors(index);
    } else {
      let patientsApproved = [...emailapprovedPatients];
      patientsApproved = patientsApproved.filter((pa) => pa.id !== index);
      if (
        patientsApproved.length < emailpatients.length &&
        checkedAll === true
      ) {
        setCheckedAll(false);
      }
      setEmailApprovedPatients(patientsApproved);
    }
  };

  const patientsFound = (data) => {
    if (smsBody) {
      if (selectedDoctors.length > 0) {
        setupdateFlag(true);
        setApprovedPatients([...selectedDoctors]);
        setopenSlugList(false);
      } else {
        setApprovedPatients([...selectedDoctors]);
      }
    } else {
      if (data.length > 0) {
        setupdateFlag(true);
        setEmailApprovedPatients([...data]);
        setopenSlugList(false);
      } else {
        setEmailApprovedPatients([...data]);
      }
    }
  };
  const closeShareSlug = () => {
    setclicked("");
    setopenSmsTab(false);
    setsmsBody(true);
    props.closeSlugModal();
  };
  const handleCheckAllDoctors = (event) => {
    setSearchedPatient("");
    let patientsAvailable = [...doctors];
    let patientsSelected = [...selectedDoctors];
    setCheckedAll(event.target.checked);
    patientsAvailable.forEach((p) => {
      p.selected = event.target.checked;
      if (event.target.checked) {
        if (!patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected.push(p);
        }
      } else {
        if (patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected = patientsSelected.filter((ps) => ps.id !== p.id);
        }
      }
    });
    setselectedDoctors(patientsSelected);
    setDoctors(patientsAvailable);
  };

  const handleSelectedDoctor = () => {
    staff_context.setSelectedDoctor(selectedDoctors);
    localStorage.setItem("selectedDoctor", JSON.stringify(selectedDoctors));
    let obj = [
      {
        clinic_id: null,
        doctors: selectedDoctors,
      },
    ];
    // console.log(" ----> c1", obj);
    localStorage.setItem(
      LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
      JSON.stringify(obj)
    );
    setDynamicCookieForUser(
      LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
      JSON.stringify(obj),
      setCookie
    );
    if (
      JSON.stringify(selectedDoctors) !== JSON.stringify(selectedDoctorsDup)
    ) {
      localStorage.removeItem("staff_selected_dr");
    }
    // localStorage.removeItem("staff_selected_dr");
    onHide();
  };

  return (
    <>
      <div className="dm-heading d-flex justify-content-between">
        <p className="dm-heading-text">Select Doctor Accounts</p>
        <span className="float-right cursor-pointer" onClick={onHide}>
          <i className="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      <>
        <div className="container list-drawer">
          <div className="container py-2 px-0 px-md-2 pb-1">
            <div className=" my-2">
              <>
                <StaffSearchbar
                  onChange={(e) => onSubmit({ search_string: e.target.value })}
                  inputText={inputText}
                  clearData={onClearData}
                  placeholder={"Search for Account Name or Mobile No."}
                />
                {selectedDoctors.length > 0 ? (
                  <div className="m-2 my-3">
                    {/* <hr className="my-1" /> */}
                    <div
                      className="selected-contacts py-2 boder-0 " //slug-contact-list
                      style={{ overflow: "auto", overflowY: "hidden" }}
                    >
                      {selectedDoctors.map((sp) => (
                        <SelectedDoctorsNew
                          key={sp.id}
                          {...sp}
                          removeSelectedDoctors={removeSelectedDoctors}
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className={"total-dr"}>
                  <p className="m-0 mt-3 p-1 total-dr-heading">
                    Total Doctors ({filteredDoctors.length})
                  </p>
                </div>
                {/* <div className="select-all my-2">
                      <input
                        type="checkbox"
                        id="select-all"
                        checked={checkedAll}
                        onChange={handleCheckAllDoctors}
                      />
                      <label htmlFor="select-all" className="m-3">
                        Select All Contacts
                      </label>
                    </div> */}

                <div className="contact-container">
                  <input
                    id={"select-all"}
                    type={"checkbox"}
                    className={"d-none"}
                    checked={checkedAll}
                    onChange={handleCheckAllDoctors}
                  />
                  <div className="d-flex my-3">
                    <label htmlFor={"select-all"} className="no-image m-0 mr-3">
                      <p className="initials m-0">
                        {checkedAll ? <CheckOutlinedIcon /> : "All"}
                      </p>
                    </label>
                    <label
                      htmlFor={"select-all"}
                      className={"d-flex align-items-center m-0"}
                    >
                      <p className="m-0" style={{ color: "#17BAE0" }}>
                        {"Select All"}
                      </p>
                    </label>
                  </div>
                </div>
                {filteredDoctors.length > 0 ? (
                  <div
                    className="contact-list pb-1 container_scroll"
                    style={{
                      minHeight: "21vh",
                      maxHeight: "21vh",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {filteredDoctors.map((doctor, index) => (
                      <DoctorContactsNew
                        key={doctor.id}
                        {...doctor}
                        handleCheckDoctorContacts={handleCheckDoctorContacts}
                      />
                    ))}
                  </div>
                ) : (
                  <>
                    <p className="text-center text-danger">No Doctor Found</p>
                  </>
                )}
              </>
            </div>
          </div>
          <div className="d-flex justify-content-center my-2">
            <button
              type="button"
              className="btn border share-button rounded-pill  mt-1 mb-1 px-4"
              // onClick={patientsFound}
              onClick={handleSelectedDoctor}
              disabled={selectedDoctors.length > 0 ? false : true}
            >
              Select
            </button>
          </div>
        </div>
      </>
    </>
  );
};
export default AllDoctorsContent;
